import { FC, ReactNode } from "react";

import {
  Card,
  Background,
  Container,
  Content,
  Header,
  Logo,
  ContentWrapper,
} from "./full-screen-box-layout.styles";
import { Logo as HeaderLogo } from "@topi/ui/components/logo/logo";
import { brand } from "@topi/ui/styles/tokens/tokens";

export interface FullScreenBoxLayoutProps {
  children?: ReactNode;
  className?: string;
  hasColorfulBackground?: boolean;
}

export const FullScreenBoxLayout: FC<FullScreenBoxLayoutProps> = ({
  children,
  className,
  hasColorfulBackground = false,
}) => {
  return (
    <Container className={className}>
      <Header>
        <HeaderLogo size="s" logoURL={brand.logoURL} />
      </Header>
      <Content>
        <Background $hasColorfulBackground={hasColorfulBackground}>
          <ContentWrapper>
            <Logo size="s" logoURL={brand.logoURL} />
            <Card>{children}</Card>
          </ContentWrapper>
        </Background>
      </Content>
    </Container>
  );
};
